/*
 * @Author: fangheng fangheng@wedobest.com.cn
 * @Date: 2023-07-03 17:15:48
 * @LastEditors: fangheng fangheng@wedobest.com.cn
 * @LastEditTime: 2023-07-19 17:28:23
 * @FilePath: \purchase-web\src\api\payManage\payManage.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * Create by zhuzhaoqing
 * Description: permission
 * Date: 2023/3/31 16:05
 **/
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import request from '../request'
const serveName = process.env.VUE_APP_SERVENAME

// 产品维度查询接口
// export const getProduct = () => request(`${serveName}/appManage/product`, null, 'GET')
// 包名维度查询接口
// export const getPkg = () => request(`${serveName}/appManage/pkg`, null, 'GET')
// 工作室维度查询接口
export const getStudio = () => request(`${serveName}/appManage/studio`, null, 'GET')
// 实体维度查询接口
export const getMch = () => request(`${serveName}/appManage/mch`, null, 'GET')
// 应用管理页面---支付类型查询接口
export const getPayChannelMore = () => request(`${serveName}/appManage/payChannel`, null, 'GET')
// 产品列表顶部的【市场】
export const getPlatformsList = (data?: any) => request(`${serveName}/app/platforms`, null, 'POST_JSON', data)

// 列表查询
export const getQueryList = (data: any) => request(`${serveName}/appManage/list`, null, 'POST_JSON', data)
// 根据dbtId 查询单条
export const getQuery = (data: any) => request(`${serveName}/appManage/get`, data, 'GET')
// 查询主体配置，新增的时候用的
export const getQueryFuzzy = (data: any) => request(`${serveName}/app/dbtId`, null, 'POST_JSON', data)
// 新增主体配置
export const postSave = (data: any) => request(`${serveName}/appManage/save`, null, 'POST_JSON', data)
// 修改主体配置
export const postEdit = (data: any) => request(`${serveName}/appManage/edit`, null, 'POST_JSON', data)
// 根据应用配置查询支付配置
export const queryPayDetail = (data: any) => request(`${serveName}/appManage/query`, data, 'GET')
// 根据应用配置修改支付配置
export const updateByMchId = (data: any) => request(`${serveName}/appManage/update`, null, 'POST_JSON', data)
// 查询支付配置
export const queryChannelConfig = (data: any) =>
  request(`${serveName}/app/channelConfig/query`, null, 'POST_JSON', data)
// 查询应用列表
export const queryAppList = (data: any) => request(`${serveName}/app/list`, null, 'POST_JSON', data)
// 查询公用配置
export const queryCommonConfig = (data: any) => request(`${serveName}/app/commonConfig/query`, null, 'POST_JSON', data)
// 编辑公用配置
export const saveCommonConfig = (data: any) => request(`${serveName}/app/commonConfig/save`, null, 'POST_JSON', data)
// 查询应用信息
export const queryAppInfo = (data: any) => request(`${serveName}/app/dbtId`, null, 'POST_JSON', data)
// 保存支付配置
export const saveChannelConfig = (data: any) => request(`${serveName}/app/channelConfig/save`, null, 'POST_JSON', data)
// 保存应用
export const saveAdd = (data: any) => request(`${serveName}/app/add`, null, 'POST_JSON', data)

// 账号变更记录查询接口
export const queryChangeRecord = (data: any) => request(`${serveName}/operationLog/query`, null, 'POST_JSON', data)
// 支付渠道同步产品中台
export const syncFetch = (data: any) => request(`${serveName}/app/chnl/sync`, null, 'POST_JSON', data)

// 添加app收藏
export const addCollectFetch = (data: any) => request(`${serveName}/app/collect/add`, null, 'POST_JSON', data)

// 取消app收藏
export const removeCollectFetch = (data: any) => request(`${serveName}/app/collect/remove`, null, 'POST_JSON', data)

// 添加产品授权【沙盒环境】
export const authorizationFetch = (data: any) =>
  request(`${serveName}/app/sandbox/authorization`, null, 'POST_JSON', data)
